<template>
  <div class="actions-items">
    <div v-if="selectedLines">
      <a
        class="actions-items__item"
        :title="$t(`${namespace}.table.actions.clear`)"
        @click="handleClearSelectedLines"
      >
        {{ $t(`${namespace}.table.actions.clear`) }}
      </a>

      <a
        class="actions-items__item"
        :title="$t(`${namespace}.table.actions.deleteSelectedEmployees`)"
        @click="handleDeleteSelectedEmployees"
      >
        {{ $t(`${namespace}.table.actions.deleteSelectedEmployees`) }}
      </a>
    </div>

    <div v-else>
      <a
        class="actions-items__item"
        :title="$t(`${namespace}.table.actions.export`)"
        @click="handleExportEmployees"
      >
        {{ $t(`${namespace}.table.actions.export`) }}
      </a>

      <BulkActions @reloadData="reloadData" />

      <Button
        class="actions-items__item"
        :title="$t(`${namespace}.table.actions.newEmployee`)"
        @click="$router.push({
          name: 'Employee',
          params: { type: 'cadastrar' }
        })"
      >
        {{ $t(`${namespace}.table.actions.newEmployee`) }}
      </Button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { downloadCsv, catchError } from 'corp-front-vue-commons/src/utils/functions'
import BulkActions from 'components/pages/employees/BulkActions'

export default {
  name: 'Actions',
  props: {
    selectedLines: {
      type: Number,
      default: 0
    },
    filters: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BulkActions
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show',
      openGlobalLoader: 'globalLoader/open',
      closeGlobalLoader: 'globalLoader/close'
    }),

    handleClearSelectedLines () {
      this.$emit('clearSelectedLines')
    },

    handleDeleteSelectedEmployees () {
      this.$emit('deleteSelectedEmployees')
    },

    reloadData (reload) {
      this.$emit('reloadData', reload)
    },

    async handleExportEmployees () {
      this.openGlobalLoader()

      try {
        const company = this.selectedCompany && this.selectedCompany.id
          ? this.selectedCompany.id
          : null
        const { search } = this.filters
        const { data } = await this.$apiService.employee.export(
          { company },
          { search }
        )
        downloadCsv('99Empresas_colaboradores.csv', data)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.export.success`)
        })
      } catch (error) {
        const message = error && error.response && error.response.status === 400
          ? this.$t(`${this.namespace}.export.error`)
          : this.$t('Common.genericError')
        this.showAlert({ type: 'error', message })
        catchError(error)
      }

      this.closeGlobalLoader()
    }
  }
}
</script>
